import React, { useState, useContext } from "react";
import { styled, alpha } from "@mui/material/styles";

import DeleteIcon from "@mui/icons-material/Delete";
import {
  Typography,
  Button,
  Menu,
  MenuItem,
  Divider,
  Stack,
} from "@mui/material";

// icon
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { RiUserUnfollowFill } from "react-icons/ri";
import { FaUserGraduate } from "react-icons/fa6";

// src
import "../../../../Style/actionStyle.scss";
import { AuthContext } from "../../../../Context/AuthContext";
import { translateLauguage } from "../../../../Function/Translate";
import StudentChangeClass from "./StudentChangeClass";
import StudentDropOut from "./StudentDropOut";
import StudentFinishClass from "./StudentFinishClass";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    // "& .MuiMenuItem-root": {
    //   "& .MuiSvgIcon-root": {
    //     fontSize: 18,
    //     color: theme.palette.text.secondary,
    //     marginRight: theme.spacing(1.5),
    //   },
    //   "&:active": {
    //     backgroundColor: alpha(
    //       theme.palette.primary.main,
    //       theme.palette.action.selectedOpacity
    //     ),
    //   },
    // },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));

export default function StudentEnrollmentAction({
  handleClose,
  anchorEl,
  open,
  editData,
  setRefetch,
  rowId,
  enrollmentTypeAction,
  rowDetail
}) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  const [openDropOut, setOpenDropOut] = useState(false);
  const handleOpenDropOut = () => setOpenDropOut(true);
  const handleCloseDropOut = () => setOpenDropOut(false);

  const [openGraduate, setOpenGraduate] = useState(false);
  const handleOpenGraduate = () => setOpenGraduate(true);
  const handleCloseGraduate = () => setOpenGraduate(false);

  // console.log("rowDetail", rowDetail);

  return (
    <div>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="enrollment-action-container"
      >
        <MenuItem
          onClick={() => {
            handleOpenEdit();
            handleClose();
          }}
          className="change-enroll"
          disabled={editData?.is_finished_class === true || editData?.is_drop_out === true || rowDetail?.attended_status === "Drop out" || rowDetail?.attended_status === "Certificate offer"}
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            <PublishedWithChangesIcon className="icon" />
            <Typography
              className={language === "en" ? "action-txt" : "action-txt-kh"}
            >
              {t("change_class")}
            </Typography>
          </Stack>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleOpenDropOut();
            handleClose();
          }}
          className="drop-out-enroll"
          disabled={editData?.is_finished_class === true || rowDetail?.attended_status === "Certificate offer"}
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            <RiUserUnfollowFill className="icon" />
            <Typography
              className={language === "en" ? "action-txt" : "action-txt-kh"}
            >
              {t("drop_out")}
            </Typography>
          </Stack>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleOpenGraduate();
            handleClose();
          }}
          className="end-enroll"
          disabled={editData?.is_drop_out === true || rowDetail?.attended_status === "Drop out"}
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            <FaUserGraduate className="icon" />
            <Typography
              className={language === "en" ? "action-txt" : "action-txt-kh"}
            >
              {t("finish_class")}
            </Typography>
          </Stack>
        </MenuItem>
      </StyledMenu>
      {openEdit && (
        <StudentChangeClass
          open={openEdit}
          handleClose={handleCloseEdit}
          editData={editData}
          setRefetch={setRefetch}
          rowId={rowId}
          enrollmentTypeAction={enrollmentTypeAction}
          rowDetail={rowDetail}
        />
      )}
      {openDropOut && (
        <StudentDropOut
          open={openDropOut}
          handleClose={handleCloseDropOut}
          editData={editData}
          setRefetch={setRefetch}
          rowId={rowId}
          enrollmentTypeAction={enrollmentTypeAction}
        />
      )}
      {openGraduate && (
        <StudentFinishClass
          open={openGraduate}
          handleClose={handleCloseGraduate}
          editData={editData}
          setRefetch={setRefetch}
          rowId={rowId}
          enrollmentTypeAction={enrollmentTypeAction}
        />
      )}
    </div>
  );
}
